// stores/cart.js
import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
    state: () => ({
        items: [],
        isCartOpen: false,
    }),
    getters: {
        totalPrice(state) {
            return state.items.reduce((sum, item) => sum + item.price, 0)
        },
    },
    actions: {
        addToCart(product) {
                const productCopy = { ...product, quantity: product.quantity};
                productCopy.price = product.price * product.quantity;
                this.items.push(productCopy);
        },

        removeFromCart(productId,type) {
            if(type==='package'){
            this.items = this.items.filter(item => item.uuid !== productId)
            }
            else{
                this.items = this.items.filter(item => item.productId !== productId)

            }
        },
        toggleCart() {
            this.isCartOpen = !this.isCartOpen
        },
        closeCart() {
            this.isCartOpen = false
        },
    },
})
